export default function getDefaultChartSettings() {
    return {
        chart: {
            animation: false,
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
        },
        title: {
            text: '',
        },
        plotOptions: {
            pie: {
                animation: false,
            },
        },
        credits: {
            enabled: false,
        },
    };
}
